<template>
  <div class="accountManage">
    <div>
      <span class="bindType">手机号</span>
      <span class="typeName">{{bindInfo.phoneNumber}}</span>
      <span
        class="typeOperate"
        :class="{orange:!bindInfo.phoneNumber}"
        @click="goBind"
      >{{bindInfo.bindPhone ? '已绑定' : '去绑定'}}</span>
      <img src="~assets/images/withdraw/arrow_gray.png" alt />
    </div>
    <div>
      <span class="bindType">微信</span>
      <span class="typeName">{{bindInfo.wechatNickName}}</span>
      <span class="typeOperate" :class="{orange:!bindInfo.bindWinxin}">{{bindInfo.bindWinxin ? '已绑定' : '去绑定'}}</span>
      <img src="~assets/images/withdraw/arrow_gray.png" alt />
    </div>
    <p>微信账号一旦绑定，不可解绑将提现此账号。</p>
    <div>
      <span class="bindType">QQ</span>
      <span class="typeName">{{bindInfo.qqNickName}}</span>
      <span class="typeOperate" :class="{orange:!bindInfo.bindQQ}">{{bindInfo.bindQQ ? '已绑定' : '去绑定'}}</span>
      <img src="~assets/images/withdraw/arrow_gray.png" alt />
    </div>
    <div>
      <span class="bindType">支付宝</span>
      <span class="typeName">{{bindInfo.alipayNickName}}</span>
      <span class="typeOperate" :class="{orange:!bindInfo.bindAlipay}">{{bindInfo.bindAlipay ? '已绑定' : '去绑定'}}</span>
      <img src="~assets/images/withdraw/arrow_gray.png" alt />
    </div>
    <p>支付宝账号一旦绑定，不可解绑将提现此账号。</p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      bindInfo: {
        phoneNumber:'',
        bindPhone:'',
        wechatNickName:'',
        bindWinxin:'',
        qqNickName:'',
        bindQQ:'',
        alipayNickName:'',
        bindAlipay:''
      }
    }
  },
  mounted() {
    this.$http.get(`http://easymock.233wei.cn/mock/5df8471f7967af073af3ef95/logic/user/userInfo`,{
      params: {
        sessionId: "id"
      }
    }).then(res => {
      if (res.data.data.length == 0) {
        return
      }
      this.bindInfo = res.data.data
    })
  },
  methods: {
    goBind() {
      Android.bindWeChat()
    }
  }
};
</script>
<style lang='less' scoped>

.accountManage {
  background: #f8f8f8;
  height: 100%;
  .orange {
    color: #ff9500 !important;
  }
  > div {
    position: relative;
    height: 0.56rem;
    padding: 0.16rem;
    margin-bottom: 0.08rem;
    background: #fff;
    .bindType {
      color: #333;
      font-size: 0.15rem;
      float: left;
      width: 0.6rem;
    }
    .typeName {
      margin-left: 0.45rem;
      color: #666;
    }
    .typeOperate {
      float: right;
      font-size: 0.14rem;
      color: #999;
      padding-right: 0.12rem;
    }
  }
  p {
    padding-left: 0.16rem;
    color: #999;
    line-height: 0.32rem;
  }
  img {
    position: absolute;
    width: 0.12rem;
    height: 0.12rem;
    top: 0;
    right: 0.12rem;
    margin-top: 0.2rem;
  }
}
</style>